<template>
  <div class="container-md">
    <div class="row justify-content-center">
      <div class="col-auto px-5">
        <div class="py-3 text-center">
          <h3>{{ $t("signUpConfirm.title") }}</h3>
        </div>
        
        <form class="border bg-light p-3" @submit.prevent="signUpResult">
          <div class="text-center">
            <p v-html="$t('signUpConfirm.message')" class="text-body"></p>
          </div>
          <div class="p-2">
            <label for="personalName">{{ $t("signUpConfirm.personalName") }}</label>
            <p class="data">{{ $store.getters.personalName }}</p>
          </div>
          <div class="p-2">
            <label for="dateOfBirth">{{ $t("signUpConfirm.dateOfBirth") }}</label>
            <p class="data">{{ $store.getters.birth }}</p>
          </div>
          <div class="p-2">
            <label for="prefectures">{{ $t("signUpConfirm.prefectures") }}</label>
            <p class="data">{{ $store.getters.prefectures }}</p>
          </div>
          <div class="p-2">
            <label for="city">{{ $t("signUpConfirm.city") }}</label>
            <p class="data">{{ $store.getters.city }}</p>
          </div>
          <div class="p-2">
            <label for="gender">{{ $t("signUpConfirm.gender") }}</label>
            <p class="data" v-if="$store.getters.gender  === 'M'">{{ $t("signUp.male") }}</p>
            <p class="data" v-if="$store.getters.gender  === 'F'">{{ $t("signUp.female") }}</p>
            <p class="data" v-if="$store.getters.gender  === 'N'">{{ $t("signUp.notKnown") }}</p>
          </div>
           <div class="p-2">
            <label for="phoneNumber">{{ $t("signUpConfirm.phoneNumber") }}</label>
            <p class="data">{{ $store.getters.formatPhoneNumber }}</p>
          </div>
          <div class="p-2">
            <label for="email">{{ $t("common.email") }}</label>
            <p class="data">{{ $store.getters.email }}</p>
          </div>
          <div class="p-2">
            <label for="password">{{ $t("common.password") }}</label>
            <p class="data">{{ $t("signUpConfirm.passwordMask") }}</p>
          </div>
           <div class="p-2">
            <label for="companyName">{{ $t("signUpConfirm.companyName") }}</label>
            <p>{{ $store.getters.companyName }}</p>
          </div>
          <div class="row justify-content-center">
            <div class="d-grid gap-2 p-2 col-5">
              <button type="button" class="btn btn-secondary" @click="signUp()" :disabled="isButtonDisabled">
                {{ $t("signUpConfirm.signUpSubmit") }}
              </button>
            </div>
            <div class="d-grid gap-2 p-2 col-5">
              <button type="submit" class="btn btn-success" :disabled="isButtonDisabled">
                <div class="text-center" v-if="!isButtonDisabled">
                  {{ $t("signUpConfirm.resultSubmit") }}
                </div>
                <div class="text-center" v-if="isButtonDisabled">
                  {{ $t("signUpConfirm.loading") }}
                </div>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Const from '../const'

export default {
  data() {
    return {
      isButtonDisabled: false
    }
  },
  methods: {
    signUpResult() {
      this.isButtonDisabled = true
      const data = {
        name: this.$store.getters.personalName,
        birthday: this.$store.getters.birth,
        prefectures: this.$store.getters.prefectures,
        city: this.$store.getters.city,
        gender: this.$store.getters.gender,
        phone_number: String(this.$store.getters.formatPhoneNumber).replaceAll("-", ""),
        email_address: this.$store.getters.email,
        password: this.$store.getters.password,
        company_name: this.$store.getters.companyName
      }

      axios.post(Const.BASE_URL + "/user-regist",
      data, {
        headers: {
          "Authorization": this.$store.getters.token,
          "Content-Type": "application/json"
        }
      })
      .then(function() {
        // console.log(response)
        this.$store.dispatch('clearToken')
        this.$store.dispatch('clearPersonalName')
        this.$store.dispatch('clearBirth')
        this.$store.dispatch('clearPrefectures')
        this.$store.dispatch('clearCity')
        this.$store.dispatch('clearGender')
        this.$store.dispatch('clearPhoneNumber')
        this.$store.dispatch('clearFormatPhoneNumber')
        this.$store.dispatch('clearPassword')
        this.$store.dispatch('clearCompanyName')
        this.$router.push({ name: "signUpResult" })
      }.bind(this))
      .catch(function() {
        this.isButtonDisabled = false
        // console.log(error)
        this.$store.dispatch("updateTokenError", true)
        this.$router.push({ name: "login" })
      }.bind(this))
    },

    signUp() {
      this.$router.push({ name: "signUp" })
    }
  },
}
</script>

<style scoped>
.data {
  margin: 0;
}
</style>
